import React from "react";

interface FormSectionProps {
  children: React.ReactNode;
  className?: string;
}

export const FormSection: React.FC<FormSectionProps> = ({
  children,
  className = "",
}) => (
  <div
    className={`flex justify-between bg-gray-100 rounded-lg p-3 border border-bg-section ${className}`}
  >
    {children}
  </div>
);
